import { z } from "zod";

import { LayoutAccessibility } from "./LayoutRecord";

export const createLayoutFormSchema = z.object({
  accessibility: z.enum(LayoutAccessibility, {
    error: "Layout owner is required",
  }),
  name: z
    .string()
    .min(1, "Layout name is required")
    .max(120, "Layout name cannot exceed 120 characters"),
  tags: z.array(z.string()).default([]),
});

export type CreateLayoutFormFields = z.infer<typeof createLayoutFormSchema>;

export const renameLayoutFormSchema = createLayoutFormSchema.pick({
  name: true,
});

export type RenameLayoutFormFields = z.infer<typeof renameLayoutFormSchema>;
